import * as React from "react";
import { SVGProps } from "react";
function SvgShowExpandedIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m9.5 17.5 5-5-5-5v10Z" fill="#000" />
    </svg>
  );
}
export default SvgShowExpandedIcon;
